import React from "react";
import {
  Stack,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  TextField
} from "@mui/material";

const ProductFilters = ({
  data,
  selectedKitchen,
  onKitchenChange = () => {}, // Add default no-op function
  search,
  onSearchChange
}) => {
  return (
    <Stack direction={{ xs: "column", sm: "row" }} spacing={2} mb={3}>
      <FormControl size="small" sx={{ minWidth: 200 }}>
        <InputLabel id="kitchen-select-label">المطبخ</InputLabel>
        <Select
          labelId="kitchen-select-label"
          value={selectedKitchen?.id || ""}
          label="المطبخ"
          onChange={(e) => {
            const kitchen = data.find((k) => k.id === e.target.value);
            onKitchenChange(kitchen);
          }}
        >
          {data.map((k) => (
            <MenuItem key={k.id} value={k.id}>{k.name}</MenuItem>
          ))}
        </Select>
      </FormControl>
      <TextField
        label="بحث"
        variant="outlined"
        size="small"
        fullWidth
        value={search}
        onChange={onSearchChange}
      />
    </Stack>
  );
};

export default ProductFilters;
